import * as React from 'react';

const IconArrowRightLarge = (props) => (
    <svg
        fill='none'
        height={48}
        viewBox='0 0 48 48'
        width={48}
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M16.5178 5.87866L32.8714 22.2322C33.8477 23.2085 33.8477 24.7914 32.8714 25.7677L16.5178 42.1213L14.3965 40L30.3965 24L14.3965 7.99998L16.5178 5.87866Z'
            fill='currentColor'/>
    </svg>
);

export default IconArrowRightLarge;
